/* Etiquetas multiidoma en castellano. */
export default {
  "viewWrapper.language.english": "English",
  "viewWrapper.language.spanish": "Español",
  "viewWrapper.menu.bookingSearch": "My bookings",
  "viewWrapper.menu.liquidation": "Sales report",
  "viewWrapper.menu.logout": "Logout",
  "viewWrapper.menu.searcher": "Searcher",
};
